/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignFilters } from './PromotionCampaignFilters';
import {
    PromotionCampaignFiltersFromJSON,
    PromotionCampaignFiltersFromJSONTyped,
    PromotionCampaignFiltersToJSON,
} from './PromotionCampaignFilters';
import type { RedemptionLimitFrequency } from './RedemptionLimitFrequency';
import {
    RedemptionLimitFrequencyFromJSON,
    RedemptionLimitFrequencyFromJSONTyped,
    RedemptionLimitFrequencyToJSON,
} from './RedemptionLimitFrequency';
import type { PromotionCampaignTrigger } from './PromotionCampaignTrigger';
import {
    PromotionCampaignTriggerFromJSON,
    PromotionCampaignTriggerFromJSONTyped,
    PromotionCampaignTriggerToJSON,
} from './PromotionCampaignTrigger';
import type { PromotionCampaignAward } from './PromotionCampaignAward';
import {
    PromotionCampaignAwardFromJSON,
    PromotionCampaignAwardFromJSONTyped,
    PromotionCampaignAwardToJSON,
} from './PromotionCampaignAward';

/**
 * Promotion campaign definition
 * Includes all fields including system-managed ones
 * @export
 * @interface PromotionCampaign
 */
export interface PromotionCampaign {
    /**
     * 
     * @type {Date}
     * @memberof PromotionCampaign
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PromotionCampaign
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PromotionCampaign
     */
    priority: number | null;
    /**
     * 
     * @type {PromotionCampaignAward}
     * @memberof PromotionCampaign
     */
    awardConfig: PromotionCampaignAward;
    /**
     * 
     * @type {RedemptionLimitFrequency}
     * @memberof PromotionCampaign
     */
    redemptionLimitFrequency?: RedemptionLimitFrequency | null;
    /**
     * 
     * @type {PromotionCampaignFilters}
     * @memberof PromotionCampaign
     */
    filters?: PromotionCampaignFilters | null;
    /**
     * 
     * @type {number}
     * @memberof PromotionCampaign
     */
    triggerCount: number;
    /**
     * 
     * @type {PromotionCampaignTrigger}
     * @memberof PromotionCampaign
     */
    trigger: PromotionCampaignTrigger;
    /**
     * 
     * @type {Date}
     * @memberof PromotionCampaign
     */
    endAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PromotionCampaign
     */
    startAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PromotionCampaign
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotionCampaign
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCampaign
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCampaign
     */
    id: string;
}



/**
 * Check if a given object implements the PromotionCampaign interface.
 */
export function instanceOfPromotionCampaign(value: object): value is PromotionCampaign {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('awardConfig' in value) || value['awardConfig'] === undefined) return false;
    if (!('triggerCount' in value) || value['triggerCount'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PromotionCampaignFromJSON(json: any): PromotionCampaign {
    return PromotionCampaignFromJSONTyped(json, false);
}

export function PromotionCampaignFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaign {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'priority': json['priority'],
        'awardConfig': PromotionCampaignAwardFromJSON(json['awardConfig']),
        'redemptionLimitFrequency': json['redemptionLimitFrequency'] == null ? undefined : RedemptionLimitFrequencyFromJSON(json['redemptionLimitFrequency']),
        'filters': json['filters'] == null ? undefined : PromotionCampaignFiltersFromJSON(json['filters']),
        'triggerCount': json['triggerCount'],
        'trigger': PromotionCampaignTriggerFromJSON(json['trigger']),
        'endAt': json['endAt'] == null ? undefined : (new Date(json['endAt'])),
        'startAt': json['startAt'] == null ? undefined : (new Date(json['startAt'])),
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function PromotionCampaignToJSON(value?: PromotionCampaign | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'priority': value['priority'],
        'awardConfig': PromotionCampaignAwardToJSON(value['awardConfig']),
        'redemptionLimitFrequency': RedemptionLimitFrequencyToJSON(value['redemptionLimitFrequency']),
        'filters': PromotionCampaignFiltersToJSON(value['filters']),
        'triggerCount': value['triggerCount'],
        'trigger': PromotionCampaignTriggerToJSON(value['trigger']),
        'endAt': value['endAt'] == null ? undefined : ((value['endAt'] as any).toISOString()),
        'startAt': value['startAt'] == null ? undefined : ((value['startAt'] as any).toISOString()),
        'description': value['description'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

